import { Link } from "react-router-dom";

interface MobileMenuServicesProps {
  showServices: boolean;
  onServiceClick: () => void;
  onToggleServices: () => void;
}

const services = [
  { title: "Washer Repair", path: "/services/washer-repair" },
  { title: "Dryer Repair", path: "/services/dryer-repair" },
  { title: "Dishwasher Repair", path: "/services/dishwasher-repair" },
  { title: "Stove Repair", path: "/services/stove-repair" },
  { title: "Refrigerator Repair", path: "/services/refrigerator-repair" },
  { title: "Oven Repair", path: "/services/oven-repair" },
];

const MobileMenuServices = ({ 
  showServices, 
  onServiceClick, 
  onToggleServices 
}: MobileMenuServicesProps) => {
  return (
    <div className="relative">
      <button
        onClick={onToggleServices}
        className="w-full text-left text-lg font-medium text-white/90 hover:text-white px-4 py-3 rounded-lg hover:bg-white/10 transition-all duration-300"
      >
        Our Services
      </button>
      
      <div className={`pl-4 space-y-2 transition-all duration-300 ${
        showServices ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
      }`}>
        {services.map((service, index) => (
          <Link
            key={index}
            to={service.path}
            className="block text-white/80 hover:text-white px-4 py-2 rounded-lg hover:bg-white/10 transition-all duration-300"
            onClick={onServiceClick}
          >
            {service.title}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MobileMenuServices;